import { K8sIconUrl } from "@p0security/shared/integrations/constants";
import { KubernetesComponents } from "@p0security/shared/integrations/resources/kubernetes/components";
import { Typography } from "antd";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { k8sInstaller } from "./install/install";

const K8sPreamble = (
  <>
    <Typography.Paragraph>
      Enable fine-grained IAM management for Kubernetes clusters with secure
      access control via admission controller deployment.
    </Typography.Paragraph>
    <Typography.Text strong>Prerequisites:</Typography.Text>
    <ul className="preamble-list">
      <li>Access to a Kubernetes cluster on AWS, Azure, or Google Cloud</li>
      <li>
        <code>cluster-admin</code> role in the Kubernetes cluster
      </li>
      <li>
        <code>kubectl</code> and your cloud provider CLI installed
      </li>
      <li>P0 IAM integration installed for your cloud provider</li>
    </ul>
  </>
);

export const API_PATH = "integrations/ssh/config";

export const K8s = (
  props: Pick<
    InstallProps<typeof KubernetesComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "cluster", []);
  return (
    <Install<typeof KubernetesComponents>
      components={KubernetesComponents}
      installer={k8sInstaller}
      integration="k8s"
      itemKind={itemKind}
      logo={K8sIconUrl}
      preamble={K8sPreamble}
      title={"Kubernetes"}
      {...props}
    />
  );
};
